import {Box, Grid} from '@mui/material';
import AppAnimate from 'main/core/AppAnimate';
import AppCard from 'main/core/AppCard';
import AppTimeline from 'main/core/AppTimeline';
import {useWidget} from 'main/utility/hooks/useWidget';
import PropTypes from 'prop-types';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {getWidgetDataList} from 'redux/actions';
import WidgetAction from '../WidgetAction';
import WidgetTitle from '../WidgetTitle';

const TimelineWidget = ({widgetSpec, params}) => {
  const dispatch = useDispatch();
  const {widgetid, widgettitle, actions} = widgetSpec;

  const {widgetData} = useWidget(widgetid);
  const {rows = []} = widgetData || {};

  useEffect(() => {
    dispatch(getWidgetDataList(widgetid, params));
  }, [dispatch, widgetid, params]);

  return (
    <AppAnimate animation='transition.slideUpIn' delay={200}>
      <AppCard>
        <Box
          display='flex'
          flexDirection='row'
          alignItems='center'
          width={1}
          justifyContent='space-between'
        >
          <Box display='flex' alignItems='center'>
            {widgettitle && <WidgetTitle title={widgettitle} />}
          </Box>

          <Box display='flex' alignItems='center' justifyContent='flex-end'>
            {actions?.map((action, i) => {
              return (
                <Grid
                  item
                  key={i}
                  xs='auto' // Forces the item to only take the width of its content
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '0px !important', // Sometimes Grid spacing adds top padding you don't want
                    paddingBottom: '0px !important',
                  }}
                >
                  <WidgetAction
                    key={i}
                    action={action}
                    data={{
                      ...params,
                      ...widgetData,
                    }}
                  />
                </Grid>
              );
            })}
          </Box>
        </Box>

        <AppTimeline widgetSpec={widgetSpec} dataSet={rows} />
      </AppCard>
    </AppAnimate>
  );
};

TimelineWidget.propTypes = {
  widgetSpec: PropTypes.object.isRequired,
  params: PropTypes.object,
};

export default TimelineWidget;
